import Swiper from 'swiper';
import GLightbox from 'glightbox';

/*
 *  Class ProductStatus
 */
export default class HeroBaner {
    constructor() {
        this.statusItems = document.querySelectorAll('.hero-baner-slider:not(.preview)');
        this.swipers = [];
        this.isMobile = window.innerWidth < 768;

        console.log(this.statusItems, 'statusItemsstatusItemsstatusItemsstatusItems');

        this.swiperDisableSetup = {
            observer: true,
            observeParents: true,
            spaceBetween: 0,
            watchOverflow: true,
            resizeEvent: 'resize',
        };
        this.swiperDefaultSetup = {
            observer: true,
            observeParents: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 3000, // 3000ms = 3 seconds between slides
                disableOnInteraction: false, // autoplay continues after interaction
            },
            speed: 600, // transition animation duration (optional, in ms)
            resizeEvent: 'resize',
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
            },
        };
    }

    fireResizeEvent() {
        if (typeof Event === 'function') {
            // modern browsers
            window.dispatchEvent(new Event('resize'));
        } else {
            // for IE and other old browsers
            // causes deprecation warning on modern browsers
            var evt = window.document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
        }
    }

    createSwiper() {
        // Clear existing swipers
        this.swipers.forEach(swiper => {
            if (swiper) {
                swiper.destroy(true, true);
            }
        });
        this.swipers = [];

        // Initialize swiper for mobile
        for (let i = 0; i < this.statusItems.length; i++) {
            const statusItem = this.statusItems[i];
            const slides = statusItem.querySelectorAll('.swiper-slide');
            console.log(slides, 'slides');
            let swiper = slides.length < 2
                ? new Swiper(statusItem, this.swiperDisableSetup)
                : new Swiper(statusItem, this.swiperDefaultSetup);
            this.swipers.push(swiper);
        }
    }

    initSwiper() {
        const breakpoint = 992;
        if (!this.statusItems.length) return;

        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth < breakpoint;

        // Initialize or reinitialize based on mobile state
        if (this.isMobile && (!wasMobile || this.swipers.length === 0)) {
            this.createSwiper();
        } else if (!this.isMobile && wasMobile) {
            // Destroy swipers when switching to desktop
            this.swipers.forEach(swiper => {
                if (swiper) {
                    swiper.destroy(true, true);
                }
            });
            this.swipers = [];
        }

        setTimeout(this.fireResizeEvent, 200);
    }

    init() {
        this.initSwiper();
        
        // Add resize listener with debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.initSwiper();
            }, 250);
        });
    }
}
